/**
 * What is wrong right now, worst first.
 *
 * The list is supplied by DBAM's operational read model. A successful empty
 * result is the only state allowed to claim there are no alerts; unavailable
 * and failed reads remain visibly unknown.
 */

import React from 'react';
import { Panel, Button } from '@cloudsam/ui';

export default function AttentionPanel({ items = null, onAct, canAct, error }) {
    const loaded = Array.isArray(items);
    return (
        <Panel title="Alerts" count={loaded && items.length ? `${items.length} alerts` : undefined}>
            {error ? (
                <div className="panel-error">{error}</div>
            ) : !loaded ? (
                <div className="panel-note">—</div>
            ) : items.length === 0 ? (
                <div className="panel-note">
                    No Alerts
                </div>
            ) : (
                items.map((item) => {
                    // Replacing a credential changes who the recipient sees, so it
                    // belongs to administrators. Everything else here is a read or a
                    // diagnosis and is open to anybody.
                    const blocked = item.action === 'Re-authorize' && !canAct;
                    return (
                        <div key={item.key} className="attention-row">
                            <span className={`dot dot--${item.tone}`} />
                            <div>
                                <div className="attention-title">{item.title}</div>
                                <div className="attention-detail">{item.detail}</div>
                            </div>
                            <Button
                                variant="secondary"
                                disabled={blocked}
                                title={blocked ? 'Administrators only — replacing a credential changes identity' : undefined}
                                onClick={() => onAct && onAct(item)}
                            >
                                {item.action}
                            </Button>
                        </div>
                    );
                })
            )}
        </Panel>
    );
}
